import { iconFor } from '../folders/FolderIcons';

/** The app's passive mark for what is on a canvas: never a control. */
export function CanvasMark({ size = 14 }: { size?: number }) {
  const Icon = iconFor('map');
  if (!Icon) return null;
  return (
    <span className="canvas-mark" role="img" aria-label="On the canvas" title="On the canvas">
      <Icon size={size} />
    </span>
  );
}
